import api from '@/store/api';
import { athena } from '@/store/api/instances';
import type { ApiResponse } from '@bitstopco/bitstop-theme';

/**
 * Response types for enum endpoints
 */
export interface OperationsStatusesView {
  statuses?: string[];
  record_statuses?: string[];
  types?: string[];
  priorities?: string[];
  severities?: string[];
}

export interface MerchantEnumsView {
  classifications?: string[];
}

export interface ServiceTicketEnumsView {
  statuses?: string[];
  priorities?: string[];
  types?: string[];
}

export interface OperatorResource {
  id: number;
  name: string | null;
}

/**
 * RTK Query API for Resource Enums.
 */
export const resourcesEnumsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCaseEnums: build.query<ApiResponse<OperationsStatusesView>, void>({
      query: () =>
        athena({
          url: 'v2/Resources/cases',
          method: 'GET',
        }),
    }),
    getIssueEnums: build.query<ApiResponse<OperationsStatusesView>, void>({
      query: () =>
        athena({
          url: 'v2/Resources/issues',
          method: 'GET',
        }),
    }),
    getMerchantEnums: build.query<ApiResponse<MerchantEnumsView>, void>({
      query: () =>
        athena({
          url: 'v2/Resources/merchants',
          method: 'GET',
        }),
    }),
    getServiceTicketEnums: build.query<ApiResponse<ServiceTicketEnumsView>, void>({
      query: () =>
        athena({
          url: 'v2/Resources/service-tickets',
          method: 'GET',
        }),
    }),
    getOperatorResources: build.query<ApiResponse<OperatorResource[]>, void>({
      query: () =>
        athena({
          url: 'v2/Resources/operators',
          method: 'GET',
        }),
    }),
  }),
});

export const {
  useGetCaseEnumsQuery,
  useGetIssueEnumsQuery,
  useGetMerchantEnumsQuery,
  useGetServiceTicketEnumsQuery,
  useGetOperatorResourcesQuery,
} = resourcesEnumsApi;
